import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/myAvatar.svg";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
        <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              I got my first computer when I was 12 years old. Since then, I have always explored and learned the world of computers.
              That is why I became a Computer Engineer.
              <br />
              <br />I have experience working on
              <i>
                <b className="purple"> Javascript, C++, C#, R, SQL (Oracle and MySQL), NoSQL (MongoDB), Python, and Deploying Web Applications on Amazon Web Services (AWS). </b>
              </i>
              <br />
              <br />
              My field of Interest's are building new&nbsp;
              <i>
                <b className="purple">Web Technologies and Products </b> and
                also in areas where I can experiment with {" "}
                <b className="purple">
                  Cloud Services.
                </b>
              </i>
              <br />
              <br />
              Whenever possible, I also apply my passion for developing products
              with <b className="purple">Node.js</b> and
              <i>
                <b className="purple">
                  {" "}
                  Modern Javascript Library and Frameworks
                </b>
              </i>
              &nbsp; like
              <i>
                <b className="purple"> React.js and Express.</b>
              </i>
              <br />
              <br />
              I also enjoy data analysis and creating statistical reports with <b className="purple">R</b> or
              <i>
                <b className="purple">
                  {" "}
                  Python.
                </b>
              </i>
 
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
